export function sectionSchema() {
  const scriptElement = document.getElementById('scriptJSON');

  if (scriptElement) {
    scriptElement.innerText = JSON.stringify({});
  }
}
